/**
 * Strip excess vertical spacing Jodit leaves after font / list edits:
 * empty paragraphs, stacked breaks, and inline line-height styles.
 */
export function tightenRichTextSpacing(html: string): string {
  if (!html) return html;
  return html
    .replace(/\s*line-height\s*:\s*[^;"']+;?/gi, '')
    .replace(/\s*style=(["'])\s+/gi, ' style=$1')
    .replace(/\s*style=(["'])\s*\1/gi, '')
    .replace(/<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '')
    .replace(/(<br\s*\/?>\s*){2,}/gi, '<br />')
    .replace(/<(ul|ol)([^>]*)>\s+/gi, '<$1$2>')
    .replace(/\s+<\/(ul|ol)>/gi, '</$1>')
    .replace(/<li([^>]*)>\s+/gi, '<li$1>')
    .replace(/\s+<\/li>/gi, '</li>')
    .replace(/<li([^>]*)>\s*<p([^>]*)>/gi, '<li$1><p$2>')
    .replace(/<\/p>\s*<\/li>/gi, '</p></li>');
}
